(() => {
  const getErrorMessage = (payload) =>
    payload?.description || payload?.message || payload?.errors || window.cartStrings?.error || 'This item could not be added.';

  const addVariant = async (variantId, quantity = 1, trigger = null) => {
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : ['cart-icon-bubble'];

    if (cartDrawer && trigger) cartDrawer.setActiveElement(trigger);

    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
        sections,
        sections_url: window.location.pathname,
      }),
    });

    let payload = {};
    try {
      payload = await response.json();
    } catch (error) {
      throw new Error(window.cartStrings?.error || 'This item could not be added.');
    }

    if (!response.ok || payload.status) throw new Error(getErrorMessage(payload));

    if (cartDrawer && payload.sections) cartDrawer.renderContents(payload);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return payload;
  };

  window.KeebeeCart = { addVariant };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-kb-drawer-addon]');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const variantField = form.querySelector('[name="id"]');
    const errorMessage = form.querySelector('[data-kb-drawer-addon-error]');
    if (!button || !variantField) return;

    button.disabled = true;
    button.textContent = 'Adding…';
    if (errorMessage) {
      errorMessage.hidden = true;
      errorMessage.textContent = '';
    }

    try {
      await addVariant(variantField.value, 1, button);
    } catch (error) {
      if (errorMessage) {
        errorMessage.textContent = error.message;
        errorMessage.hidden = false;
      }
      button.disabled = false;
      button.textContent = 'Add';
    }
  });
})();
